import React, { useState } from "react";
import ImageUploading from "react-images-uploading";
import Moveable from "react-moveable";
import MoveableHelper from "moveable-helper";

import "./imageUploader.styles.css";

const DimensionViewable = {
  name: "dimensionViewable",
  props: {},
  events: {},
  render(moveable, React) {
    const rect = moveable.getRect();
    // Add key (required)
    // Add class prefix moveable-(required)
    return (
      <div
        key={"dimension-viewer"}
        className={"moveable-dimension"}
        style={{
          position: "absolute",
          left: `${rect.width / 2}px`,
          top: `${rect.height + 20}px`,
          background: "#4af",
          borderRadius: "2px",
          padding: "2px 4px",
          color: "white",
          fontSize: "13px",
          whiteSpace: "nowrap",
          fontWeight: "bold",
          willChange: "transform",
          transform: "translate(-50%, 0px)",
        }}
      >
        {Math.round(rect.offsetWidth)} x {Math.round(rect.offsetHeight)}
        {/* <img
          src="https://images.unsplash.com/photo-1575089976121-8ed7b2a54265?ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8ZGV2ZWxvcGVyfGVufDB8fDB8fA%3D%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60"
          alt=""
          style={{width: rect.width,
          height: rect.height}}
        /> */}
      </div>
    );
  },
};

const ImageUploader = ({ data, onHandledelete }) => {
  const [helper] = React.useState(() => {
    return new MoveableHelper();
  });
  const imageRef = React.useRef(null);
  const [isDraggable, setIsDraggable] = useState(false);
  const [strokeSettings, setStrokeSettings] = useState({
    strokeWidth: 1,
    strokeColor: "transparent",
  });
  const [radiusType, setRadiusType] = useState("Non rounded");
  const [opacity, setOpacity] = useState(1);
  const [images, setImages] = React.useState([]);
  const maxNumber = 1;
  const onChange = (imageList, addUpdateIndex) => {
    // data for submit
    console.log(imageList, addUpdateIndex);
    setImages(imageList);
  };

  const onHandleStrokeColor = (color) => {
    setStrokeSettings({
      ...strokeSettings,
      strokeColor: color.hex,
    });
  };

  const onHandleRadiusType = (type) => {
    console.log("type", type);
    setRadiusType(type);
  };

  const onHandleOpacity = (value) => {
    const opacity = value / 100;
    setOpacity(opacity);
  };

  const getStrokeWidth = (width) => {
    setStrokeSettings({ ...strokeSettings, strokeWidth: width });
  };

  const handleClick = (e) => {
    if (e.type === "click") {
      console.log("i am a click");
      setIsDraggable(false);
    } else if (e.type === "contextmenu") {
      console.log("i am a right click");
      setIsDraggable(!isDraggable);
    }
  };

  return (
    <div
      className="image--target block-wrapper"
      onClick={handleClick}
      onContextMenu={handleClick}
    >
      <ImageUploading
        multiple
        value={images}
        onChange={onChange}
        maxNumber={maxNumber}
        dataURLKey="data_url"
 
      >
        {({
          imageList,
          onImageUpload,
          onImageRemoveAll,
          onImageUpdate,
          onImageRemove,
          isDragging,
          dragProps,
        }) => (
          // write your building UI
          <div
            className="upload__image-wrapper"
            style={{
              width: 458,
              height: 458,
            }}
          >
            {imageList.length !== 0 ? (
              imageList.map((image, index) => (
                <div
                  key={index}
                  className="image-item target"
                  style={{
                    border: `${strokeSettings.strokeWidth}px solid ${strokeSettings.strokeColor}`,
                    borderRadius: radiusType === "Non rounded" ? "" : 8,
                  }}
                >
                  <img
                    src={image.data_url}
                    alt=""
                    onClick={() => onImageUpdate(index)}
                    style={{
                      opacity: opacity,
                      borderRadius: radiusType === "Non rounded" ? "" : 8,
                    }}
                    ref={imageRef}
                  />
                </div>
              ))
            ) : (
              <button
                style={
                  (isDragging ? { color: "red" } : null,
                  {
                    border: `${strokeSettings.strokeWidth}px solid ${strokeSettings.strokeColor}`,
                    width: 458,
                    height: 458,
                  })
                }
                onClick={onImageUpload}
                {...dragProps}
                className="upload__image--style"
              >
                <svg
                  width="220"
                  height="220"
                  viewBox="0 0 220 220"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M3 186.322V4C3 3.44771 3.44772 3 4 3H216C216.552 3 217 3.44772 217 4V79.4283L216.439 79.9886L138.729 157.587L64.1894 111.121C63.1017 110.442 61.6775 110.697 60.8917 111.71L3 186.322ZM3 187.64V216C3 216.552 3.44772 217 4 217H216C216.552 217 217 216.552 217 216V104.208H215.999V84.6677L140.568 159.99C139.745 160.812 138.465 160.958 137.479 160.343L62.9853 113.905L4.73198 188.983L3 187.64ZM0 216V4C0 1.79086 1.79086 0 4 0H216C218.209 0 220 1.79086 220 4V216C220 218.209 218.209 220 216 220H4C1.79086 220 0 218.209 0 216Z"
                    fill="#DCDCDC"
                    fill-opacity="0.3"
                  />
                  <ellipse
                    cx="164.407"
                    cy="55.5942"
                    rx="22.4731"
                    ry="22.4731"
                    fill="#DCDCDC"
                    fill-opacity="0.3"
                  />
                </svg>
                <span>
                  <svg
                    width="20"
                    height="19"
                    viewBox="0 0 20 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 2C6.79082 2 5 3.79085 5 6C5 6.03242 5.00047 6.06627 5.00131 6.10224C5.01219 6.56727 4.70099 6.97839 4.25047 7.09416C2.95577 7.42685 2 8.60311 2 10C2 11.6569 3.34317 13 5 13H6C6.55229 13 7 13.4477 7 14C7 14.5523 6.55229 15 6 15H5C2.23861 15 0 12.7614 0 10C0 7.93746 1.2482 6.16845 3.02926 5.40373C3.32856 2.36995 5.88746 0 9 0C11.2236 0 13.1629 1.20934 14.199 3.00324C17.4207 3.10823 20 5.75289 20 9C20 12.3137 17.3138 15 14 15C13.4477 15 13 14.5523 13 14C13 13.4477 13.4477 13 14 13C16.2092 13 18 11.2091 18 9C18 6.79085 16.2092 5 14 5C13.8893 5 13.78 5.00447 13.6718 5.01322C13.2449 5.04776 12.8434 4.8066 12.6734 4.4135C12.0584 2.99174 10.6439 2 9 2ZM9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071C12.3166 11.0976 11.6834 11.0976 11.2929 10.7071L11 10.4142V18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18V10.4142L8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L9.29289 7.29289Z"
                      fill="#C3C3C3"
                    />
                  </svg>
                  Upload image
                </span>
              </button>
            )}
          </div>
        )}
      </ImageUploading>
      <Moveable
        target={imageRef}
        ables={[DimensionViewable]}
        props={{
          dimensionViewable: true,
        }}
        draggable={true}
        resizable={true}
        scalable={true}
        rotatable={true}
        onDragStart={helper.onDragStart}
        onDrag={helper.onDrag}
        onResizeStart={helper.onResizeStart}
        onResize={helper.onResize}
        onRotateStart={helper.onRotateStart}
        onRotate={helper.onRotate}
      />
    </div>
  );
};

export default ImageUploader;
